export const ICON_BUTTON_SIZE = '40px';